var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Button, EmptyState, EmptyStateBody, EmptyStateHeader, EmptyStateIcon, EmptyStateVariant } from '@patternfly/react-core';
import { ExclamationCircleIcon } from '@patternfly/react-icons';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';
const useStyles = createUseStyles({
    emptyStateUnavailable: {
        color: 'var(--pf-global--danger-color--100)',
        '& svg': { color: 'var(--pf-global--danger-color--100)' }
    },
    emptyStateLinkButton: {
        padding: '0',
    }
});
const UnavailableContent = (_a) => {
    var { statusPageUrl = '', statusPageLinkText = 'status page', unavailableTitleText = 'This page is temporarily unavailable', unavailableBodyPreStatusLinkText = 'Try refreshing the page. If the problem persists, contact your organization administrator or visit our', unavailableBodyPostStatusLinkText = 'for known outages.', ouiaId = 'UnavailableContent' } = _a, props = __rest(_a, ["statusPageUrl", "statusPageLinkText", "unavailableTitleText", "unavailableBodyPreStatusLinkText", "unavailableBodyPostStatusLinkText", "ouiaId"]);
    const classes = useStyles();
    return (React.createElement(EmptyState, Object.assign({ variant: EmptyStateVariant.lg, className: clsx(classes.emptyStateUnavailable), "data-ouia-component-id": ouiaId }, props),
        React.createElement(EmptyStateHeader, { titleText: unavailableTitleText, icon: React.createElement(EmptyStateIcon, { icon: ExclamationCircleIcon, "data-ouia-component-id": `${ouiaId}-icon` }), "data-ouia-component-id": `${ouiaId}-header`, headingLevel: "h5" }),
        React.createElement(EmptyStateBody, { "data-ouia-component-id": `${ouiaId}-body` },
            unavailableBodyPreStatusLinkText,
            ' ',
            React.createElement(Button, { component: 'a', className: clsx(classes.emptyStateLinkButton), variant: 'link', href: statusPageUrl, target: "_blank", rel: "noopener noreferrer", ouiaId: `${ouiaId}-link-button` }, statusPageLinkText),
            ' ',
            unavailableBodyPostStatusLinkText)));
};
export default UnavailableContent;
